# A HOSTED COMPONENT ROW, RENDERED AS ONE OF THE CLIENT'S SCREENS — card
# 6ac022cba664bc34d57be8c5.
#
# hostedScreen(entry) is the component hosted_routes puts in the route table
# for a manifest entry. When its route opens it:
#
#   1. publishes what a compiled Component needs on window — React (its JSX
#      pragma is window.i18nCreateElement, which app-route already publishes,
#      and fragments are window.React.Fragment), clientAPI (the session's API;
#      componentCookieClient mints the component-read cookie from its
#      Authorization header, so without it the load would be anonymous), and
#      componentLibraries (filled from this bundle's own modules,
#      component_libraries.coffee — one React, one MUI theme on the page);
#   2. loads the row through schema's componentCookieClient.importComponentModule
#      ONLY, from the URL the server chose (common/hostedApp.coffee: the
#      setting is a raw launch URL on dev/QA, a CloudFront deploy URL on prod).
#      Deployed, that is the entry's moduleUrl. Raw, it is an ABSOLUTE same-origin URL. The bundle is served from the CDN
#      (assets.elephantlearning.com), and a relative import() resolves against
#      the importing module's URL — that is the CDN, a cross-origin fetch the
#      instance's CORS policy refuses (RULINGS). location.origin is the
#      instance the page was served by;
#   3. renders it inside its OWN boundary, so a broken row reports its crash and
#      offers the built-in dashboard instead of taking the shell down.
#
# Props a hosted component gets (umbrella 6ac01b76…e442, step 6): route(name,
# params) — which reaches the built-in screens too, so a mobile dashboard's
# "continue coursework" opens the existing play screens — back, app
# (window.app: account, students, activeStudentId), isApp, screenWidth, and
# params, which are also spread as props the way BaseApp hands its query to a
# screen.
import React, { lazy, Suspense } from 'react'
import Button from '@mui/material/Button'
import { importComponentModule } from '../../../../../schema/framework/shared/componentCookieClient.coffee'
import * as crashReporter from '../crash_reporter.coffee'
import { LoadingScreen as Loading } from '../common.coffee'

librariesReady = null

publishGlobals = ->
  window.React ?= React
  window.clientAPI ?= window.app?.loopbackAPI
  librariesReady ?= import('./component_libraries.coffee').then (mod) ->
    window.componentLibraries ?= {}
    for own name, lib of mod.default when not window.componentLibraries[name]?
      window.componentLibraries[name] = lib
    return

# Deployed: the module the deploy wrote (entry.moduleUrl). Raw: this instance's
# live compile of the row.
export componentUrl = (entry, win = window) ->
  return entry.moduleUrl if entry?.moduleUrl
  "#{win.location.origin}/api/components/#{encodeURIComponent entry.componentId}/load"

class HostedBoundary extends React.Component
  constructor: (props) ->
    super props
    @state = {error: null}

  @getDerivedStateFromError: (error) -> {error}

  componentDidCatch: (error, info) ->
    console.error "[hosted] #{@props.entry.name} (component #{@props.entry.componentId}) failed: #{error?.message or error}"
    # Reported, never dropped: the frames are same-origin /api/components/<id>/load
    # URLs, which the reporter treats as our own code (crash_reporter suppressionReason).
    crashReporter.report 'boundary', error,
      componentStack: info?.componentStack
      context: {hostedRoute: @props.entry.name, hostedComponent: @props.entry.componentId}

  render: ->
    return @props.children unless @state.error?
    <div className="hosted-screen-error" style={{padding: '32px 16px', textAlign: 'center'}}>
      <p>{window.t?("This screen could not be opened.") or "This screen could not be opened."}</p>
      <Button variant="contained" color="primary" onClick={=> @props.route 'dashboard'}>
        {window.t?("Go to Dashboard") or "Go to Dashboard"}
      </Button>
    </div>

# The classic title bar, for a screen shown in the classic app (the Screens
# App, card 6ac022cba664bc34d57be8c9): the built-in screens each render their
# own, and a hosted screen has to be given one, or the page has no menu and no
# way back. Loaded lazily, as the built-in screens' chunks load it. A mobile App
# screen gets none: the Mobile Shell row is its frame.
TitleBar = lazy -> import('../title_bar.coffee')

export hostedScreen = (entry, opts = {}) ->
  Lazy = lazy ->
    publishGlobals()
    await librariesReady
    importComponentModule componentUrl(entry)
  Screen = (props) ->
    hostedProps = Object.assign {}, props.params,
      params: props.params
      route: props.route
      back: props.back
      href: props.href
      app: window.app
      isApp: window.app?.isApp?() ? false
      screenWidth: window.innerWidth
    screen =
      <HostedBoundary entry={entry} route={props.route}>
        <Suspense fallback={<Loading/>}>
          <Lazy {...hostedProps} />
        </Suspense>
      </HostedBoundary>
    return screen unless opts.titleBar
    <div className="hosted-screen">
      <Suspense fallback={null}><TitleBar /></Suspense>
      {screen}
    </div>
  Screen.displayName = "Hosted(#{entry.name})"
  Screen
